<template>
  <MyOrdersSingleOrderCard v-bind="data" :date="data.lastDrawDate">
    <template #header>
      <MyOrdersWinningBadge v-if="data.hasWinnings" />
      <MyOrdersStatusBadgeSingleOrder
        v-else-if="data.status === PlaySlipOrderStatus.Cancelled"
        :status="data.status"
      />
    </template>
  </MyOrdersSingleOrderCard>
</template>

<script lang="ts" setup>
import {
  type ClosedPlaySlipOrder,
  PlaySlipOrderStatus,
} from '#api/shared/@types/generated/backend/graphql-schema-types'

type MyOrdersSingleOrderCardProps = {
  data: ClosedPlaySlipOrder
}

defineProps<MyOrdersSingleOrderCardProps>()
</script>
